import {z} from "zod"
import {GraphNode} from "#graph/nodes/graph/node"
import {registerNode} from "#graph/decorators/register-node"
import type {Evaluator} from "#graph/evaluators/types"
import {DynamicParameterDefinition} from "#graph/nodes/dynamic-parameter/definition"

@registerNode
export class DynamicParameter<ValueType> extends GraphNode<ReturnType<typeof DynamicParameterDefinition<ValueType>>> {
    static nodeClass = "DynamicParameter"
    static definition = DynamicParameterDefinition(z.any())

    set(value: ValueType) {
        this.replaceParameters({value})
    }

    override run = async (_evaluator: Evaluator): Promise<ValueType> => {
        return this.parameters.value!
    }

    override runSync = (_evaluator: Evaluator): ValueType => {
        return this.parameters.value!
    }
}

@registerNode
export class DynamicNumberParameter extends DynamicParameter<number> {
    static override nodeClass = "DynamicNumberParameter"
    static override definition = DynamicParameterDefinition(z.number())
}
